import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core';
import { HlmButton } from '@lite-workspace/shared/helm-ui/button';
import { HlmDropdownMenuImports } from '@lite-workspace/shared/helm-ui/dropdown-menu';

/** Shared mobile cabinet navigation trigger. The host supplies its menu and icon. */
@Component({
  selector: 'hlm-app-shell-navigation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
  imports: [HlmButton, HlmDropdownMenuImports],
  template: `
    <button
      hlmBtn
      type="button"
      variant="ghost"
      size="icon"
      [hlmDropdownMenuTrigger]="menu()"
      align="start"
      side="bottom"
      [attr.aria-label]="label()"
      class="relative ml-2 shrink-0 after:absolute after:-inset-1.5 after:content-[''] lg:hidden"
    >
      <ng-content />
    </button>
  `,
})
export class HlmAppShellNavigation {
  readonly menu = input.required<TemplateRef<unknown>>();
  readonly label = input('Навигация');
}
